<template>
  <footer class="tw-bg-green tw-p-8 tw-text-white">
    <div class="tw-mx-auto tw-max-w-7xl">
      <div class="tw-flex tw-flex-col tw-gap-8 md:tw-grid md:tw-grid-cols-4">
        <!-- Logo and Info -->
        <div>
          <div class="tw-mb-3 tw-flex tw-items-center">
            <v-icon class="tw-mr-1 tw-text-white">mdi-calendar-blank</v-icon>
            <span class="tw-text-2xl tw-font-medium">timeful</span>
          </div>
          <div class="tw-mb-6 tw-leading-snug">
            Made with 💚 by
            <a
              href="https://github.com/jonytf"
              target="_blank"
              class="tw-text-white tw-underline"
              >jonathan liu</a
            >
          </div>
          <div class="tw-mb-6 tw-leading-snug">
            Hosted by
            <a href="https://nolog.cz/">
              <svg style="width: 8em; display: inline;" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" class="logo" clip-rule="evenodd" viewBox="0 0 400 60">
                <path fill="currentColor" d="M60 0H0v60h20V19h20v41h20V0Zm80 60h50V41h-30V0h-20v60ZM130 0H70v60h60V0ZM90 19v22h20V19H90ZM260 0h-60v60h60V0Zm-40 19v22h20V19h-20Zm50 41h60V25h-20v16h-20V19h40V0h-60v60ZM372.2 2.9l6.5 20.7H400l-17.2 12.8 6.6 20.7-17.2-12.8L355 57.1l6.5-20.7-17.2-12.8h21.3l6.6-20.7Z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
div:has(a) {
  @apply tw-leading-none;
}
a {
  @apply tw-text-white/80 !important;
}
a:hover {
  @apply tw-text-white !important;
}
</style>

<script>
import { mapActions } from "vuex"

export default {
  name: "Footer",
  data() {
    return {
      contractAddress: "2uHvhSasjzHm4PPAWaVpuU7yKtd4yUGYx6WK2oxutQnm",
    }
  },
  computed: {
    contractAddressTruncated() {
      return (
        this.contractAddress.slice(0, 6) +
        "..." +
        this.contractAddress.slice(-4)
      )
    },
  },
  methods: {
    ...mapActions(["showInfo"]),
    copyContractAddress() {
      navigator.clipboard
        .writeText(this.contractAddress)
        .then(() => {
          this.showInfo("Contract address copied to clipboard!")
        })
        .catch((err) => {
          console.error("Failed to copy contract address: ", err)
          // Optionally, show an error message to the user
        })
    },
  },
}
</script>
